export const IMAGES = {
  bagHero:
    "https://static.prod-images.emergentagent.com/jobs/e71ad0e8-fb87-4b50-8bee-a896cddb9f76/images/6effccd6415cdaa9913e9bdf6cd7d34186fbac7b37f86da7ec463a2e1bf067b8.jpeg",
  bagAngle:
    "https://static.prod-images.emergentagent.com/jobs/e71ad0e8-fb87-4b50-8bee-a896cddb9f76/images/6effccd6415cdaa9913e9bdf6cd7d34186fbac7b37f86da7ec463a2e1bf067b8.jpeg",
  lifestyleCoffee:
    "https://images.pexels.com/photos/20207912/pexels-photo-20207912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  lifestyleGym:
    "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  logoMark:
    "https://static.prod-images.emergentagent.com/jobs/e71ad0e8-fb87-4b50-8bee-a896cddb9f76/images/23d37b3614d43d315baa04390c2d87c623642ed430b12c7f8498bb7a3235ac15.jpeg",
  pour:
    "https://images.unsplash.com/photo-1522012188892-24beb302783d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxwb3VyaW5nJTIwZGFyayUyMGNvZmZlZXxlbnwwfHx8fDE3ODY2NTI3MDR8MA&ixlib=rb-4.1.0&q=85",
  espresso:
    "https://images.unsplash.com/photo-1475296204602-08d15839e95f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwb3VyaW5nJTIwZGFyayUyMGNvZmZlZXxlbnwwfHx8fDE3ODY2NTI3MDR8MA&ixlib=rb-4.1.0&q=85",
  athlete:
    "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxlbmVyZ2V0aWMlMjBhdGhsZXRlJTIwdHJhaW5pbmd8ZW58MHx8fHwxNzg2NjUyNzA0fDA&ixlib=rb-4.1.0&q=85",
  ropes:
    "https://images.unsplash.com/photo-1599058917212-d750089bc07e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxlbmVyZ2V0aWMlMjBhdGhsZXRlJTIwdHJhaW5pbmd8ZW58MHx8fHwxNzg2NjUyNzA0fDA&ixlib=rb-4.1.0&q=85",
  mushroom:
    "https://images.unsplash.com/photo-1699520201084-99a632e413c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtdXNocm9vbSUyMGZvcmVzdCUyMG1hY3JvfGVufDB8fHx8MTc4NjY1MjcwM3ww&ixlib=rb-4.1.0&q=85",
};

// Your Shopify store domain. Buttons deep-link to the Shopify cart so checkout
// + Supliful fulfillment happen on Shopify.
export const SHOPIFY_DOMAIN = "shop.overclockproducts.com";

// Single Shopify variant published by Supliful (connected to Supliful
// fulfillment). Every order uses this variant; bundles change only quantity.
export const SHOPIFY_VARIANT_ID = "49032226472090";

// Subscribe & Save selling plan ID (from your Shopify Subscriptions/Recharge/Seal
// app). One selling plan usually applies across all variants. Leave "" until you
// have it — subscribe checkout is guarded until then.
export const SUBSCRIPTION_SELLING_PLAN_ID = "305804738714";

// Ad tracking — paste your pixel IDs to activate. Leave "" to disable.
export const META_PIXEL_ID = "1600802201478866";
export const TIKTOK_PIXEL_ID = "";

// Retail $41.95/bag. Bundle + Subscribe & Save (10% off) pricing.
export const BUNDLES = [
  {
    bags: 1,
    label: "1 BAG",
    servings: "30 servings",
    base: 41.95,
    price: 41.95,
    sub: 37.76,
    qty: 1,
    tag: null,
  },
  {
    bags: 3,
    label: "3 BAGS",
    servings: "90 servings",
    base: 125.85,
    price: 99.95,
    sub: 89.96,
    qty: 3,
    tag: "SAVE $26",
    popular: true,
  },
  {
    bags: 6,
    label: "6 BAGS",
    servings: "180 servings",
    base: 251.7,
    price: 189.95,
    sub: 170.96,
    qty: 6,
    tag: "SAVE $62",
    best: true,
  },
];

export const FREE_SHIP_THRESHOLD = 50;
export const SHIP_FEE = 5.99;

export const REVIEWS = [
  {
    name: "Marcus D.",
    role: "Founder · Series A SaaS",
    stars: 5,
    text: "I run on 5 hours of sleep and back-to-back calls. This is the first coffee that gives me the lock-in without the 2pm collapse. Genuinely changed my mornings.",
  },
  {
    name: "Priya S.",
    role: "CrossFit Athlete",
    stars: 5,
    text: "No jitters before training, no crash after. Lion's Mane focus is real — I feel dialed in for hours. Tastes like actual good coffee, not dirt.",
  },
  {
    name: "Tyler R.",
    role: "Software Engineer",
    stars: 5,
    text: "Switched from 4 espressos a day. Now it's one cup of God Mode and I'm locked in until lunch. My heart rate literally thanked me.",
  },
  {
    name: "Jordan M.",
    role: "Ultramarathoner",
    stars: 5,
    text: "Cordyceps for endurance is not a gimmick. Cleanest sustained energy I've had from any coffee, and I've tried them all.",
  },
  {
    name: "Alicia K.",
    role: "Creative Director",
    stars: 4,
    text: "Was skeptical about 'mushroom coffee' — expected it to taste weird. It just tastes like smooth dark roast. The calm focus is unreal.",
  },
  {
    name: "Devon W.",
    role: "Night-shift Nurse",
    stars: 5,
    text: "Keeps me sharp through a 12-hour shift and I still fall asleep after. That's never happened with regular coffee.",
  },
];
